'use strict';

wbApp.controller('ActivityScheduleInstructorsCtrl', ['$scope', '$modal', '$translate', '$filter', 'gridSortSvc','activityInstructorSvc',
function ($scope, $modal, $translate, $filter, gridSortSvc, activityInstructorSvc) {

    $scope.activityWeeks = null;
    $scope.selection = null;
    $scope.activityID = null;
    $scope.semesterID = null;

    var selectedActivity = null;

    $scope.$on('activityScheduleSelectionChanged', function (e, data) {
        if (data.selection && data.selection.length > 0) {
            if (!angular.equals(data.selection, $scope.selection)) {
                $scope.semesterID = data.semesterID;
                $scope.instructors = activityInstructorSvc.getWeekModelByIntervals(data.semesterID, data.activityID, data.selection);

                $scope.instructors.$promise.then(function () {
                    _.forEach($scope.instructors, function (w) {
                        w.singlePeriodProgramOnly = !!selectedActivity ? selectedActivity.singlePeriodProgramOnly : false;
                    });
                });

                $scope.activityWeeks = data.activityWeeks;
                $scope.selection = data.selection;
                $scope.activityID = data.activityID;
            }
        } else {
            if (!!$scope.instructors) {
                $scope.instructors.length = 0;
            }

            $scope.semesterID = null;
            $scope.activityWeeks = data.activityWeeks;
            $scope.selection = null;
            $scope.activityID = null;
        }
    });


    $scope.$on('activitySelectionChanged', function (e, data) {
        if (data.activityID) {
            $scope.activityID = data.activityID;
        }

        selectedActivity = data.activity;
    });

    $scope.acivityScheduleInstructorsGridOptions = {
        name: 'selectedActivityScheduleInstructors',
        columns: [
            {
                dataField: 'fullName',
                dataType: 'string',
                caption: $translate.instant("TXT_HUMAN_NAME"),
                width: '180px',
                sortOrder: 'asc',
                calculateSortValue: function (data) {
                    return gridSortSvc.sortHumanFullName2(data, 'fullName')
                }
            },
            {
                dataField: 'monday',
                dataType: 'string',
                caption: $translate.instant("TXT_MONDAY"),
                calculateCellValue: function (rowData) {
                    return $filter('datePartOccupied')(rowData.monday);
                },
                width: '70px',
            },
            {
                dataField: 'tuesday',
                dataType: 'string',
                caption: $translate.instant("TXT_TUESDAY"),
                calculateCellValue: function (rowData) {
                    return $filter('datePartOccupied')(rowData.tuesday);
                },
                width: '70px'
            },
            {
                dataField: 'wednesday',
                dataType: 'string',
                caption: $translate.instant("TXT_WEDNESDAY"),
                calculateCellValue: function (rowData) {
                    return $filter('datePartOccupied')(rowData.wednesday);
                },
                width: '70px'
            },
            {
                dataField: 'thursday',
                dataType: 'string',
                caption: $translate.instant("TXT_THURSDAY"),
                calculateCellValue: function (rowData) {
                    return $filter('datePartOccupied')(rowData.thursday);
                },
                width: '70px'
            },
            {
                dataField: 'friday',
                dataType: 'string',
                caption: $translate.instant("TXT_FRIDAY"),
                calculateCellValue: function (rowData) {
                    return $filter('datePartOccupied')(rowData.friday);
                },
                width: '70px'
            },
            {
                dataField: 'saturday',
                dataType: 'string',
                caption: $translate.instant("TXT_SATURDAY"),
                calculateCellValue: function (rowData) {
                    return $filter('datePartOccupied')(rowData.saturday);
                },
                width: '70px'
            },
            {
                dataField: 'sunday',
                dataType: 'string',
                caption: $translate.instant("TXT_SUNDAY"),
                calculateCellValue: function (rowData) {
                    return $filter('datePartOccupied')(rowData.saturday);
                },
                width: '70px'
            },
            {
                dataField: 'notes',
                dataType: 'string',
                caption: $translate.instant("TXT_LBL_NOTE"),
                calculateCellValue: function (rowData) {
                    return $filter('aggregateNotes')(rowData.notes);
                }
            }
        ],
        shouldDisableAdd: function () { return !$scope.selection; },
    }

    $scope.instructorDetailModel = null;

    $scope.onRowAdd = function () {
        $scope.instructorDetailModel = {
            isNew: true,
            employeeID: null,
            activityID: $scope.activityID,
            selection: $scope.selection.slice(0),
            activityWeeks: $scope.activityWeeks
        };

        detailDialogPromise.$promise.then(function () {
            $scope.activityInstructorsDetailError = null;
            detailDialogPromise.$scope.singlePeriodProgramOnly = !!selectedActivity ? selectedActivity.singlePeriodProgramOnly : false;
            detailDialogPromise.show();
        });
    }

    $scope.onRowEdit = function (instructor) {

        $scope.instructorDetailModel = {
            isNew: false,
            employeeID: instructor.employeeID,
            activityID: $scope.activityID,
            selection: $scope.selection.slice(0),
            activityWeeks: $scope.activityWeeks
        };

        detailDialogPromise.$promise.then(function () {
            $scope.activityInstructorsnDetailError = null;
            detailDialogPromise.$scope.singlePeriodProgramOnly = !!selectedActivity ? selectedActivity.singlePeriodProgramOnly : false;
            detailDialogPromise.show();
        });
    }

    $scope.onActivityInstructorSave = function () {
        detailDialogPromise.hide();
        // Reload data 
        $scope.instructors = activityInstructorSvc.getWeekModelByIntervals(
            $scope.semesterID,
            $scope.activityID,
            $scope.selection);

        $scope.instructors.$promise.then(function () {
            _.forEach($scope.instructors, function (w) {
                w.singlePeriodProgramOnly = !!selectedActivity ? selectedActivity.singlePeriodProgramOnly : false;
            });
        });
    }

    var detailDialogPromise = $modal({
        templateUrl: 'activities/activity-instructor/detail.html',
        show: false,
        scope: $scope
    });


}]);